import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

export default function useDataOnSubmit(props) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ args, value }) {
    switch (args.type) {
      case 'skip': {
        if (typeof props.onClose === 'function') {
          props.onClose()
        }

        return
      }
      default: {
        if (!value.connection_id || !value.patient_id) {
          return notify(
            notifyError('Please, assign the connection to the patient')
          )
        }

        let mutationResponse = await executeMutation({
          connection_id: value.connection_id,
          patient_id: value.patient_id,
        })

        if (mutationResponse.error) {
          return notify(
            notifyError(
              'An error has occurred assigning the connection to the patient'
            )
          )
        }

        // Perform in this way to prevent a race condition and ensuring that onSubmit will run before closing the modal
        // if the submit fails, it will run close anyway
        try {
          if (typeof props.onSubmit === 'function') {
            props.onSubmit()
          }
        } catch (error) {}

        if (typeof props.onClose === 'function') {
          props.onClose()
        }
      }
    }
  }
}
